/* ============================================================
   THE KAMIKAZE - global theme script
   Reveals · nav · full-screen menu · Shopify cart · lightbox
   Section-specific behaviour lives in its own section file.
   ============================================================ */
(function(){
'use strict';
const K = window.kamikaze || {};
const $  = (s,c)=> (c||document).querySelector(s);
const $$ = (s,c)=> Array.prototype.slice.call((c||document).querySelectorAll(s));
const RM = matchMedia('(prefers-reduced-motion: reduce)').matches;

/* ---------- Film grain (generated, no asset request) -------- */
if($('.grain')){
  const n=110, c=document.createElement('canvas'); c.width=c.height=n;
  const x=c.getContext('2d'), d=x.createImageData(n,n), p=d.data;
  for(let i=0;i<p.length;i+=4){ const v=Math.random()*255|0; p[i]=p[i+1]=p[i+2]=v; p[i+3]=26; }
  x.putImageData(d,0,0);
  document.documentElement.style.setProperty('--grain-src','url('+c.toDataURL()+')');
}

/* ---------- Reveal ------------------------------------------ */
const io = (K.reveals === false || RM) ? null : new IntersectionObserver(es=>{
  es.forEach(e=>{ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
},{rootMargin:'0px 0px -8% 0px', threshold:0.06});

function observe(root){
  const scope = root || document;
  if(!io){ $$('[data-reveal], .mask', scope).forEach(el=>el.classList.add('in')); return; }
  $$('[data-reveal]', scope).forEach(el=>{ if(!el.classList.contains('in')) io.observe(el); });
  $$('.mask', scope).forEach(m=>{
    if(m.classList.contains('in')) return;
    if(!m.style.getPropertyValue('--d')){
      const sibs = Array.prototype.slice.call(m.parentNode.children).filter(c=>c.classList.contains('mask'));
      m.style.setProperty('--d', (sibs.indexOf(m)*90)+'ms');
    }
    io.observe(m);
  });
}
window.kamikazeObserve = observe;

/* ---------- Toast ------------------------------------------- */
let toastT;
function toast(msg){
  const t=$('#toast'); if(!t) return;
  t.textContent=msg; t.classList.add('on');
  clearTimeout(toastT); toastT=setTimeout(()=>t.classList.remove('on'), 2600);
}
window.kamikazeToast = toast;

/* ---------- Nav --------------------------------------------- */
const nav=$('#nav'); let lastY=0;
addEventListener('scroll',()=>{
  const y=scrollY;
  nav.classList.toggle('is-stuck', y>40);
  nav.classList.toggle('is-hidden', y>320 && y>lastY && !$('#menu').classList.contains('on'));
  const cta=$('#navcta');
  if(cta) cta.style.display = (y>620 && innerWidth>=720) ? '' : 'none';
  lastY=y;
},{passive:true});

/* ---------- Full-screen menu -------------------------------- */
const menu=$('#menu'), burger=$('#burger');
function setMenu(on){
  menu.classList.toggle('on',on); burger.classList.toggle('on',on);
  burger.setAttribute('aria-expanded',String(on));
  document.body.classList.toggle('is-locked',on);
}
burger.onclick = ()=> setMenu(!menu.classList.contains('on'));
$('#menuclose').onclick = ()=> setMenu(false);

/* ---------- Cart -------------------------------------------- */
const drawer=$('#drawer'), scrim=$('#scrim');
function setCart(on){
  drawer.classList.toggle('on',on); scrim.classList.toggle('on',on);
  document.body.classList.toggle('is-locked',on);
}
$('#cartbtn').addEventListener('click', e=>{ e.preventDefault(); setCart(true); });
$('#cartclose').onclick=()=>setCart(false);
scrim.onclick=()=>setCart(false);

function paint(sections){
  const html = sections && sections['cart-drawer'];
  if(!html) return;
  const doc = new DOMParser().parseFromString(html,'text/html');
  const src = doc.querySelector('#cart-drawer-render');
  if(!src) return;
  $('#cartbody').innerHTML = src.innerHTML;
  const n = parseInt(src.dataset.count||'0',10);
  $('#carttotal').textContent = src.dataset.total || '';
  const dot=$('#cartdot'); dot.textContent=n; dot.classList.toggle('on', n>0);
  const co=$('.drawer__foot button[name="checkout"]'); if(co) co.disabled = n===0;
}

async function post(url, body){
  const r = await fetch(url, {
    method:'POST',
    headers:{'Content-Type':'application/json','Accept':'application/json'},
    body: JSON.stringify(Object.assign({sections:'cart-drawer'}, body))
  });
  const j = await r.json();
  if(!r.ok) throw new Error(j.description || j.message || 'Cart error');
  return j;
}

async function addToCart(id, qty){
  try{
    const j = await post(K.addUrl + '.js', {items:[{id:id, quantity:qty||1}]});
    paint(j.sections); toast('Added to cart'); setCart(true);
  }catch(err){ toast(err.message); }
}
window.kamikazeAdd = addToCart;

$('#cartbody').addEventListener('click', async e=>{
  const b = e.target.closest('[data-qty]'); if(!b) return;
  b.disabled = true;
  try{
    const j = await post(K.changeUrl + '.js', {id:b.dataset.key, quantity:parseInt(b.dataset.qty,10)});
    paint(j.sections);
  }catch(err){ toast(err.message); b.disabled=false; }
});

/* Product forms post through the drawer instead of navigating */
document.addEventListener('submit', async e=>{
  const form = e.target.closest('form[action*="/cart/add"]'); if(!form) return;
  e.preventDefault();
  const btn = form.querySelector('[type="submit"]');
  const id  = form.querySelector('[name="id"]');
  if(!id) return;
  if(btn){ btn.disabled=true; btn.dataset.label=btn.innerHTML; btn.textContent='Adding…'; }
  const qty = form.querySelector('[name="quantity"]');
  await addToCart(id.value, qty ? parseInt(qty.value,10) : 1);
  if(btn){ btn.disabled=false; btn.innerHTML=btn.dataset.label; }
});

/* ---------- Lightbox ---------------------------------------- */
const lb=$('#lbox'); let lbSet=[], lbI=0;
function showLB(list,i){
  lbSet=list; lbI=(i+list.length)%list.length;
  const g=lbSet[lbI], img=$('#lbimg'), vid=$('#lbvid');
  if(vid) vid.pause();
  if(g.video && vid){
    vid.src=g.video; vid.poster=g.src; vid.style.display='';
    img.style.display='none';
    vid.play().catch(()=>{});
  } else {
    if(vid){ vid.removeAttribute('src'); vid.style.display='none'; }
    img.style.display=''; img.src=g.src; img.alt=g.cap||'';
  }
  $('#lbcap').textContent = g.cap || '';
  $('#lbcount').textContent = (lbI+1)+' / '+lbSet.length;
  lb.classList.add('on'); document.body.classList.add('is-locked');
}
function hideLB(){
  const v=$('#lbvid'); if(v){ v.pause(); v.removeAttribute('src'); }
  lb.classList.remove('on'); document.body.classList.remove('is-locked');
}
window.kamikazeLightbox = showLB;
$('#lbprev').onclick=()=>showLB(lbSet,lbI-1);
$('#lbnext').onclick=()=>showLB(lbSet,lbI+1);
$('#lbclose').onclick=hideLB;
lb.addEventListener('click', e=>{ if(e.target===lb) hideLB(); });

addEventListener('keydown', e=>{
  if(e.key==='Escape'){ hideLB(); setMenu(false); setCart(false); }
  if(!lb.classList.contains('on')) return;
  if(e.key==='ArrowLeft') showLB(lbSet,lbI-1);
  if(e.key==='ArrowRight') showLB(lbSet,lbI+1);
});

/* ---------- Shared chip groups ------------------------------ */
document.addEventListener('click', e=>{
  const c = e.target.closest('.chips[data-chip] .chip'); if(!c) return;
  const grp = c.closest('.chips');
  $$('.chip',grp).forEach(x=>x.classList.remove('on')); c.classList.add('on');
});

/* ---------- Theme editor re-init ---------------------------- */
document.addEventListener('shopify:section:load', e=> observe(e.target));

observe();
})();
